import http_request from './http_request'
import config from 'config'

function getMatchingPairs(id, jwt) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}
	return http_request.get(config.api + 'matching_pairs/' + id)
		.withHeaders(headers)
		.send()
}

function save(instructions, timer, id, final) {
	return http_request.put(config.api + 'matching_pairs/' + id)
		.send({
			instructions,
			timer,
			final,
		})
}

function savePair(id, activePair) {
	const method = activePair.id ? 'put' : 'post'
	const putId = activePair.id ? `/${activePair.id}` : ''

	const formatMatrixForServer = matrix => {

		const newMatrix = [...matrix, 400, 400, 270, 270]
		return JSON.stringify(newMatrix.map(value => parseFloat(value.toFixed(3))))
	}

	return http_request[method](config.api + 'matching_pairs/' + id + '/pair' + putId)
		.send({
			card1: {
				id: activePair.card1.id,
				type: activePair.card1.type,
				value: activePair.card1.type === 'image' ?
					formatMatrixForServer(activePair.card1.value.matrix, activePair.card1.value.originalSize) :
					activePair.card1.value,
			},
			card2: {
				id: activePair.card2.id,
				type: activePair.card2.type,
				value: activePair.card2.type === 'image' ?
					formatMatrixForServer(activePair.card2.value.matrix, activePair.card2.value.originalSize) :
					activePair.card2.value,
			},

		})
}

function addCard(id) {
	return http_request.post(config.api + 'matching_pairs/' + id + '/card')
		.send()
}

function deletePair(pairId, mpId) {
	return http_request.delete(config.api + 'matching_pairs/' + mpId + '/pair/' + pairId)
		.send()
}


export default {
	getMatchingPairs,
	save,
	savePair,
	addCard,
	deletePair,
}
